export default __webpack_public_path__ + "static/media/logo-square.d873d2c9.png";